import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { cn } from "@/shadcn";
const Drawer = DialogPrimitive.Root;
const DrawerTrigger = DialogPrimitive.Trigger;

const DrawerPortal = ({ className, ...props }) => (
  <DialogPrimitive.Portal className={cn(className)} {...props} />
);

DrawerPortal.displayName = DialogPrimitive.Portal.displayName;

const DrawerOverlay = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Overlay
    ref={ref}
    className={cn(
      "fixed inset-0 z-50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 dark:bg-slate-950/80",
      className
    )}
    {...props}
  />
));
DrawerOverlay.displayName = DialogPrimitive.Overlay.displayName;

const DrawerRight = React.forwardRef(
  ({ className, noCloseIcon, children, ...props }, ref) => (
    <DrawerPortal className="blur-none backdrop:blur-none">
      <DrawerOverlay className="bg-black/20" />
      <DialogPrimitive.Content
        ref={ref}
        className={cn(
          `fixed h-full -right-[100%] data-[state=open]:right-0 top-0 z-50 grid gap-4 bg-white transition-all duration-1000 ease-linear`,
          className
        )}
        {...props}
      >
        {children}
        {!noCloseIcon && (
          <DialogPrimitive.Close className="absolute right-3 lg:right-5 top-[10px] rounded-sm hover:text-secondary-500">
            <X className="h-6 w-6" />
            <span className="sr-only">Close</span>
          </DialogPrimitive.Close>
        )}
      </DialogPrimitive.Content>
    </DrawerPortal>
  )
);
DrawerRight.displayName = DialogPrimitive.Content.displayName;

const DrawerTop = React.forwardRef(
  ({ className, isOpen, onClose, children, ...props }, ref) => (
    <DrawerPortal className="blur-none backdrop:blur-none">
      {/* <DrawerOverlay onClick={onClose} className="bg-black/20" /> */}
      <DialogPrimitive.Content
        ref={ref}
        className={cn(
          `fixed left-0 w-screen z-40 h-screen bg-primary-500 ${
            isOpen ? "top-0" : "-top-[100vh]"
          }`,
          className
        )}
        {...props}
      >
        {children}
        <DialogPrimitive.Close
          onClick={onClose}
          className="absolute right-[50px] top-[50px] rounded-sm text-white hover:text-secondary-500"
        >
          <X className="h-6 w-6" />
          <span className="sr-only">Close</span>
        </DialogPrimitive.Close>
      </DialogPrimitive.Content>
    </DrawerPortal>
  )
);
DrawerTop.displayName = DialogPrimitive.Content.displayName;

export { Drawer, DrawerTrigger, DrawerRight, DrawerTop };
